import React from 'react';
import { PlayerIcon } from '../../assets/icons';
import RoleCreatePage from '../RoleManagement/RoleCreatePage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './PlayerCreatePage.module.css';

const PlayerCreatePage: React.FC = () => (
  <RoleCreatePage config={ROLE_CONFIGS.player} styles={styles} Icon={PlayerIcon} />
);

export default PlayerCreatePage;
